// © Microsoft Corporation. All rights reserved.
import React, { Fragment, useState } from 'react';
import { Stack, DefaultButton } from '@fluentui/react';
import {
  endCallTitleStyle,
  stackItemStyles,
  buttonsStackTokens,
  stackBtnItemStyles,
  buttonStyle,
  stackStyles
} from './styles/Survey.styles';

export interface SurveyProps {
  message: string;
  darkColor: string;
  defaultRating(value: any): any;
}

export const Survey = (props: SurveyProps): JSX.Element => {
  const [rating, setRating] = useState(0);
  const handleChange = (value: any) => {
    setRating(value);
    props.defaultRating(value);
  }
  return (
    // <Stack styles={stackStyles}>
    <Fragment>
      {/* <Stack.Item styles={stackItemStyles}>
        <div className={endCallTitleStyle}>{props.message}</div> */}
      <div style={{ cursor: 'pointer' }}>
        <StarRating
          count={5}
          size={30}
          value={rating}
          activeColor={props.darkColor}
          inactiveColor={'#ddd'}
          onChange={handleChange} />
      </div>
      {/* </Stack.Item> */}
      {/* <Stack.Item styles={stackBtnItemStyles}>
        <Stack horizontal tokens={buttonsStackTokens} horizontalAlign="start" verticalAlign="start">
          <div style={{ cursor: 'pointer' }}>
            <StarRating
              count={5}
              size={30}
              value={rating}
              activeColor={props.darkColor}
              inactiveColor={'#ddd'}
              onChange={handleChange} />
          </div>
        </Stack>
      </Stack.Item> */}
    </Fragment>
    // </Stack>
  );
};

export interface StarProps {
  count?: any;
  value?: any;
  inactiveColor?: string;
  size?: number;
  activeColor?: string;
  onChange(value: any): void;
}

const StarRating = (props: StarProps): JSX.Element => {
  const { count, value, inactiveColor, size, activeColor, onChange } = props;
  // short trick 
  const stars = Array.from({ length: count }, () => '🟊')

  // Internal handle change function
  const handleChange = (value: any) => {
    onChange(value + 1);
  }

  return (
    <div>
      {stars.map((s, index) => {
        let style = inactiveColor;
        if (index < value) {
          style = activeColor;
        }
        return (
          <span className={"star"}
            key={index}
            style={{ color: style, width: size, height: size, fontSize: size }}
            onClick={() => handleChange(index)}>{s}</span>
        )
      })}
    </div>
  )
}